import Autocomplete from './Autocomplete.view';

export default Autocomplete;
